export class GeographicMenuModuleState {
    filter: GeographicMenuFilterState;
}

export class GeographicMenuFilterState {
    regionId?: number;
    departmentId?: number;
    townId?: number;
}
